module.exports = BMapGL;